import React, { Component } from 'react';
import { Client } from "@petfinder/petfinder-js";
import Search from './Search';
import Animals from './Animals';

const API_KEY = process.env.REACT_APP_API_KEY;
const API_SECRET = process.env.REACT_APP_SECRET;

// Using the Petfinder SDK to connect to Petfinder API 
const client = new Client({ apiKey: API_KEY, secret: API_SECRET });

class App extends Component {
  state = { pets: [] };

  // Using the search query to get data from Petfinder
  searchPet = (petQuery) => {
    client.animal.search({ location: `${petQuery}` })
      .then((response) => {
        console.log('response', response.data.animals);
        this.setState({ pets: response.data.animals });
      })

      .catch(function (error) {
        console.log('ERROR', error)
      });
  }

  render() {
    return (
      <div>
        <div className='container-fluid text-center p-5'>
          <h1>Pet Search</h1>
        </div>
        <Search searchPet={this.searchPet} />
        <Animals pets={this.state.pets} />
      </div>
    )
  }
}

export default App;